export default __webpack_public_path__ + "static/media/67.ba841701.jpeg";